import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=836201ca&scoped=true&lang=pug"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836201ca",
  null
  
)

export default component.exports